/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
function plural(val) {
  const n = val;
  return 5;
}
export default ["mgh", [["wichishu", "mchochil’l"], u, u], u, [["S", "J", "J", "J", "A", "I", "J"], ["Sab", "Jtt", "Jnn", "Jtn", "Ara", "Iju", "Jmo"], ["Sabato", "Jumatatu", "Jumanne", "Jumatano", "Arahamisi", "Ijumaa", "Jumamosi"], ["Sab", "Jtt", "Jnn", "Jtn", "Ara", "Iju", "Jmo"]], u, [["K", "U", "R", "C", "T", "M", "S", "N", "T", "K", "M", "Y"], ["Kwa", "Una", "Rar", "Che", "Tha", "Moc", "Sab", "Nan", "Tis", "Kum", "Moj", "Yel"], ["Mweri wo kwanza", "Mweri wo unayeli", "Mweri wo uneraru", "Mweri wo unecheshe", "Mweri wo unethanu", "Mweri wo thanu na mocha", "Mweri wo saba", "Mweri wo nane", "Mweri wo tisa", "Mweri wo kumi", "Mweri wo kumi na moja", "Mweri wo kumi na yel’li"]], u, [["HY", "YY"], u, ["Hinapiya yesu", "Yopia yesu"]], 0, [6, 0], ["dd/MM/y", "d MMM y", "d MMMM y", "EEEE, d MMMM y"], ["HH:mm", "HH:mm:ss", "HH:mm:ss z", "HH:mm:ss zzzz"], ["{1} {0}", u, u, u], [",", ".", ";", "%", "+", "-", "E", "×", "‰", "∞", "NaN", ":"], ["#,##0.###", "#,##0%", "¤ #,##0.00", "#E0"], "MZN", "MTn", "MZN", {
  "JPY": ["JP¥", "¥"],
  "MZN": ["MTn"],
  "USD": ["US$", "$"]
}, "ltr", plural];
